import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { categoriesSet } from '../../store/categoriesSlice';
import { useTranslation } from 'react-i18next';
import useApiGet from '../../hooks/useApiGet';
import useCategories from '../../hooks/useCategories';
import Loader from '../common/Loader';
import Error from '../common/Error';
import SearchExhibitors from './SearchExhibitors';
import SearchActivities from './SearchActivities';
import FilterSwitch from './FilterSwitch';
import FilterCategoryList from './FilterCategoryList';
import FilterCategoryMain from './FilterCategoryMain';
import FilterCountry from './FilterCountry';
import FilterClear from './FilterClear';
import './Filter.css';
import FilterDate from './FilterDate';
/**
 * Компонент отрисовки фильтра выдачи.
 */
const Filter = ({ event }) => {
	const { t, i18n } = useTranslation();
    const lang = i18n.language;
    const dispatch = useDispatch();
    const location = useLocation();
	const method = '/categories';
    const [ filterClass, setFilterClass ] = useState('filter-hide');
	const [ params, setParams ] = useState({ event: event._id, lang });
	const [ data, error, isLoading ] = useApiGet({ method, params });
    const [ folders, orphans, addon, admin ] = useCategories({ lang });

    useEffect(() => {
        setParams({ event: event._id, lang });
    }, [ lang, event ]);

    // Сохраним полученные категории для разбора в useCategories и вообще
    useEffect(() => {
        if(data) {
            dispatch(categoriesSet(data.categories));
        }
    }, [ data, dispatch ]);

    if(isLoading) return(<div className='Content-left Filter'><Loader/></div>);
    if(error) return(<div className='Content-left Filter'><Error error={error}/></div>);

	return (
		<div className='Content-left Filter'>
            
            <div className='mobile'>
                <h1>{event.name[lang]}</h1>
            </div>
            <div className='desktop'>
	    	    <h2>{t('filter.title')}</h2>
            </div>

            {location.pathname.includes('exhibitors')
            ? <SearchExhibitors event={event}/>
            : <SearchActivities/>}

            <FilterSwitch
                setFilterClass={setFilterClass}
                title={t('filter.settings')}
            />

            <div className={`${filterClass} with-scroll`}>
                <div className='list'>
                    <FilterCountry event={event}/>
                    <FilterCategoryMain folders={folders} orphans={orphans} title={event.category_name.main[lang]}/>
                    <FilterCategoryList list={addon} title={event.category_name.addon[lang]} border={true}/>
                    <FilterCategoryList list={admin} title={event.category_name.admin[lang]} border={true}/>
                    <FilterDate event={event}/>
                    <FilterClear/>
                </div>
            </div>
		</div>
	);
};

export default Filter;
